import React from "react";
import "./jobTagPill.scss";

// Change #100308 - one Job Tag drawn as a coloured pill with its icon. Used on
// the job header, My Day and the Settings > Jobs > Tags table, so a tag looks
// the same wherever it shows up.
//
// Takes either a JobTag row ({ Name, Icon, CssColour* , FlagHighlight }) or a
// JobToJobTag row, whose tag columns arrive prefixed JobTag_.
export const tagLook = (tag) => ({
  name: tag?.JobTag_Name ?? tag?.Name ?? "",
  icon: tag?.JobTag_Icon ?? tag?.Icon ?? "",
  background: tag?.JobTag_CssColourBackground ?? tag?.CssColourBackground,
  border: tag?.JobTag_CssColourBorder ?? tag?.CssColourBorder,
  text: tag?.JobTag_CssColourText ?? tag?.CssColourText,
  highlight:
    String(tag?.JobTag_FlagHighlight ?? tag?.FlagHighlight ?? "0") === "1",
});

export default function JobTagPill({ tag, iconOnly = false, onRemove, title }) {
  const look = tagLook(tag);
  return (
    <span
      className={`job-tag-pill ${look.highlight ? "is-highlight" : ""} ${
        iconOnly ? "is-icon-only" : ""
      }`}
      style={{
        background: look.background || "#F3EEFC",
        color: look.text || "#865CE6",
        borderColor: look.border || look.background || "transparent",
      }}
      title={title || (iconOnly ? look.name : undefined)}
    >
      {look.icon ? <i className={look.icon} aria-hidden="true" /> : null}
      {!iconOnly && <span>{look.name}</span>}
      {onRemove && (
        <button
          type="button"
          className="job-tag-pill__remove"
          onClick={(e) => {
            e.stopPropagation();
            onRemove();
          }}
          aria-label={`Remove ${look.name}`}
          title="Remove tag"
        >
          <i className="ri-close-line" />
        </button>
      )}
    </span>
  );
}
